<template>
  <div>
    <TransitionGroup
      name="notification"
      tag="div"
      class="message-notification-container"
    >
      <div v-for="alarm in alarmList" :key="alarm.id" class="notification-card">
        <div class="notification-body">
          <div class="notification-row device-name-row">
            <span class="row-value device-name" :title="alarm.name || '-'">{{
              alarm.name || "-"
            }}</span>
          </div>
          <div class="notification-row" style="margin-top: 10px;">
            <span class="row-label">[类型]</span>
            <span class="row-value type-value">{{
              alarm.alertName || "-"
            }}</span>
          </div>
          <div class="notification-row">
            <span class="row-label">[区域]</span>
            <span class="row-value">{{ alarm.area || "-" }}</span>
          </div>
          <div class="notification-row">
            <span class="row-label">[内容]</span>
            <span
              class="row-value content-ellipsis"
              :title="alarm.content || '-'"
              >{{ alarm.content || "-" }}</span
            >
          </div>
          <div class="notification-row">
            <span class="row-label">[时间]</span>
            <span class="row-value">{{ alarm.createTime || "-" }}</span>
          </div>
        </div>
        <div class="notification-footer">
          <button class="btn-handle" @click="handleAlarm(alarm)">
            <img
              src="/static/image/equip/ts-ljcl-btn.png"
              alt=""
              class="btn-icon"
            />
            立即处理
          </button>
          <button class="btn-close" @click="closeAlarm(alarm.id)">
            <img
              src="/static/image/equip/ts-gb-btn.png"
              alt=""
              class="btn-icon"
            />
            关闭
          </button>
        </div>
      </div>
    </TransitionGroup>
    <alarmDetailsDlg
      :dlgState0="dlgState"
      :dlgQuery="dlgQuery"
      :dlgType="dlgType"
      @closeDlg="closeDlg"
    />
    <el-dialog
      :close-on-click-modal="false"
      title="异常报警处理"
      :visible.sync="dlgShow"
      width="1200px"
      top="30px"
      append-to-body
    >
      <el-row type="flex" justify="space-between">
        <el-col
          :span="11"
          class="giveAlarmDlgCol"
          v-if="giveAlarmRow.type == 0"
        >
          <div
            style="font-weight: bolder;color: #49a2ff;line-height: 16px;position: relative;"
          >
            <span style="position: absolute;top: -1px;">|</span>
            <span class="ml10">设备图纸</span>
            <el-button
              style="margin-left:320px"
              type="success"
              @click="viewLargerImg"
              size="mini"
              icon="el-icon-check"
            >
              <span>查看大图</span>
            </el-button>
          </div>
          <div style="flex: 1;position: relative" class="mt10 dflex">
            <div class="drop-box dflex" v-if="equipmentDrawing">
              <div class="drop-right">
                <!-- <el-upload style="width: 980px; height: 660px" v-if="!dropDiaImgUrl" class="avatar-uploader" title="点击上传图片" action="" :show-file-list="false" :before-upload="uploadFunc1">
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload> -->

                <img
                  :src="equipmentDrawing"
                  :style="`width:${imgWidth}px; height:${imgHeight}px`"
                />
                <!-- <el-image
                  class="drop-right-img"
                  :preview-src-list="equipmentDrawingList"
                  :src="equipmentDrawing"
                  alt=""
                >
                  <div slot="error" class="image-slot">
                    <i class=""></i>
                  </div>
                </el-image> -->

                <!-- <div style="width: 400px; height: 400px; border: 1px solid #000">
            
          </div> -->
              </div>

              <div class="drop-left flex1">
                <!-- 相对定位 可移动的 -->
                <div class="drop-left-p">
                  <img
                    class="icon_cgq_right"
                    style="position: absolute;"
                    v-for="(item, index) of dropDiaXYList"
                    :key="index"
                    :style="
                      `left:${(item.left + 10 + 10) * iconScale1 -
                        10}px; top:${(item.top + 10 + 10) * iconScale1 - 10}px`
                    "
                    :data-index="index"
                    name="sensor-p-item"
                    :title="item.name"
                    @mousedown="moveRightFunc($event, index)"
                    :src="`/static/image/${item.imgName || 'icon_sbxq'}.gif`"
                    alt=""
                  />
                  <!-- <div
              class="icon_cgq_right success"
              v-for="(item,index) of dropDiaXYList"
              :key="index"
              :data-index="index"
              :style="`left:${item.left}px; top:${item.top}px`"
              name='sensor-p-item'
              :title="item.name"
              @mousedown="moveRightFunc($event, index)">
            </div> -->
                </div>
                <!-- 绝对定位 固定的 -->
                <div class="drop-left-a" style="display:none">
                  <div
                    v-for="(item, index) of dropDiaList"
                    :key="index"
                    :data-index="index"
                    @mousedown="moveLeftFunc($event, index)"
                    class="sensor-item sensor-a-item"
                  >
                    <div class="flex sensor-item-top">
                      <!-- << 图片 -->
                      <img
                        class="icon_cgq"
                        :src="`/static/image/${item.imgName || 'icon_cgq'}.png`"
                        alt=""
                      />
                      <!-- <div class="icon_cgq success"></div> -->
                      <!-- >> 图片 -->

                      <div
                        :class="
                          `flex1 not-select ${
                            item.isSelected ? 'fsuccess fbold' : ''
                          } `
                        "
                        style="line-height: 23px"
                      >
                        {{ item.name }}
                      </div>
                      <i
                        v-if="item.iconState"
                        class="el-icon-back fdanger fr"
                        @click="backFunc(index)"
                        style="font-size: 22px"
                        title="撤销"
                      ></i>
                      <!-- {{positionX}}
                {{positionY}} -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div></div>
          </div>
        </el-col>
        <el-col :span="6" class="giveAlarmDlgCol">
          <div
            style="font-weight: bolder;color: #49a2ff;line-height: 16px;position: relative;"
          >
            <span style="position: absolute;top: -1px;">|</span>
            <span class="ml10">报警信息</span>
          </div>
          <div>
            <span style="font-weight: bolder;">区域:</span>
            <span style="color: #767778;">{{ giveAlarmRow.area }}</span>
          </div>
          <div>
            <span style="font-weight: bolder;">报警设备:</span>
            <span style="color: #767778;">{{ giveAlarmRow.equipName }}</span>
          </div>
          <div>
            <span style="font-weight: bolder;">报警区域:</span>
            <span style="color: #767778;">{{
              giveAlarmRow.equipRoomName == "" || !giveAlarmRow.equipRoomName
                ? giveAlarmRow.area + giveAlarmRow.equipName
                : giveAlarmRow.equipRoomName + giveAlarmRow.equipName
            }}</span>
          </div>
          <div>
            <span style="font-weight: bolder;">报警类型:</span>
            <span style="color: #767778;">{{ giveAlarmRow.alertName }}</span>
          </div>
          <div>
            <span style="font-weight: bolder;">报警时间:</span>
            <span style="color: #767778;">{{ giveAlarmRow.createTime }}</span>
          </div>
          <div>
            <span style="font-weight: bolder;">责任人:</span>
            <span style="color: #767778;"></span>
          </div>
          <div>
            <span style="font-weight: bolder;">责任人联系电话:</span>
            <span style="color: #767778;"></span>
          </div>
          <div>
            <span style="font-weight: bolder;">报警内容:</span>
            <span style="color: #767778;">{{ giveAlarmRow.content }}</span>
          </div>
        </el-col>
        <el-col :span="6" class="giveAlarmDlgCol" v-if="giveAlarmRow.type == 0">
          <div
            style="font-weight: bolder;color: #49a2ff;line-height: 16px;position: relative;"
          >
            <span style="position: absolute;top: -1px;">|</span>
            <span class="ml10">设备信息</span>
          </div>
          <div>
            <span style="font-weight: bolder;">{{
              alarmDetailData.pojo.name
            }}</span>
          </div>
          <div>
            <span style="font-weight: bolder;">区域:</span>
            <span style="color: #767778;">{{ giveAlarmRow.area }}</span>
          </div>
          <div>
            <span style="font-weight: bolder;">设备类型:</span>
            <span style="color: #767778;">{{
              alarmDetailData.pojo.nodeArchivesName
            }}</span>
          </div>
          <!-- <div>
            <span style="font-weight: bolder;">资产状态:</span>
            <span style="color: #49a73e;">闲置{{}}</span>
          </div> -->
          <div>
            <span style="font-weight: bolder;">IOT设备状态:</span>
            <span style="color: #767778;" v-if="alarmDetailData.pojo.state == 2"
              >离线</span
            >
            <span style="color: #767778;" v-if="alarmDetailData.pojo.state == 1"
              >报警</span
            >
            <span style="color: #767778;" v-if="alarmDetailData.pojo.state == 0"
              >正常</span
            >
          </div>
          <div>
            <span style="font-weight: bolder;">设备机构:</span>
            <span style="color: #767778;">{{ userInfo.projectName }}</span>
          </div>
          <div>
            <span style="font-weight: bolder;">设备区域:</span>
            <span style="color: #767778;">{{
              alarmDetailData.pojo.equipRoomName
            }}</span>
          </div>
          <div>
            <span style="font-weight: bolder;">安装位置:</span>
            <span style="color: #767778;">{{ giveAlarmRow.alarmAddress }}</span>
          </div>
        </el-col>
      </el-row>
      <div
        class="mt20"
        style="font-size: 14px;font-weight: bolder;"
        v-if="
          (giveAlarmRow.alarmVideo && giveAlarmRow.alarmVideo != '') ||
            (giveAlarmRow.alarmPicture && giveAlarmRow.alarmPicture != '')
        "
      >
        报警实况
      </div>
      <div>
        <el-row>
          <el-col :span="12">
            <div
              v-if="giveAlarmRow.alarmVideo && giveAlarmRow.alarmVideo != ''"
            >
              <video
                ref="graphics"
                style="width: 500px;max-height: 200px;"
                id="video"
                controls
              >
                <source :src="giveAlarmRow.alarmVideo" type="video/mp4" />
              </video>
            </div>
          </el-col>
          <el-col :span="12">
            <div
              v-if="
                giveAlarmRow.alarmPicture && giveAlarmRow.alarmPicture != ''
              "
            >
              <el-image
                style="width: 100%;height: 200px;max-width: 500px;"
                v-if="giveAlarmRow.alarmPicture"
                class="upload-img"
                :preview-src-list="srcList"
                :src="this.giveAlarmRow.alarmPicture"
                alt=""
              ></el-image>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="mt20" style="font-size: 14px;font-weight: bolder;">
        报警处理
      </div>
      <el-form
        class="mt20"
        ref="dlgForm"
        :rules="dlgRules"
        :model="dlgData"
        label-position="right"
        label-width="110px"
        size="mini"
        @submit.native.prevent
        :disabled="dlgType == 'info' ? true : false"
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="处理类型" prop="status">
              <el-radio-group v-model="dlgData.status" @change="radioChange()">
                <el-radio :label="1" :disabled="isDis">处理中</el-radio>
                <el-radio :label="2">已处理</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="预计处理时长"
              v-if="dlgData.status == '1'"
              prop="handlerHours"
            >
              <el-radio-group v-model="dlgData.handlerHours" :disabled="isDis">
                <el-radio :label="1">1小时</el-radio>
                <el-radio :label="6">6小时</el-radio>
                <el-radio :label="12">12小时</el-radio>
                <el-radio :label="24">24小时</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          label="结果"
          prop="handlerResultStr"
          v-if="dlgData.status == '2'"
        >
          <el-select
            style="width: 200px;"
            v-model="dlgData.handlerResultStr"
            placeholder="请选择"
            @change="gjSelectProductType"
          >
            <el-option
              v-for="item in gjSelect"
              :key="item.id"
              :label="item.name"
              :value="{ value: item.id, label: item.name }"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-row v-if="dlgData.status == '2'">
          <el-col :span="6">
            <el-form-item label="现场确认人员" prop="handler">
              <el-input
                style="width: 200px;"
                v-model="dlgData.handler"
                @focus="showUserTree"
                placeholder="请选择现场确认人员"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="确认时间" prop="confirmationTime">
              <el-date-picker
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="dlgData.confirmationTime"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          label="备注"
          prop="handlerRemark"
          v-if="dlgData.status == '2'"
        >
          <el-input
            :rows="3"
            type="textarea"
            resize="none"
            v-model="dlgData.handlerRemark"
            placeholder="请输入内容"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dlgShow = false" icon="el-icon-back">关闭</el-button>
        <el-button
          v-if="dlgType != 'info'"
          type="success"
          @click="subGiveAlarmDlg"
          icon="el-icon-check"
        >
          <span>提交</span>
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="设备图纸"
      :close-on-click-modal="false"
      :visible.sync="dropDiaState"
      width="1024px"
      top="30px"
      append-to-body
    >
      <div style="width: 981px; overflow-x:hidden">
        <div
          class="dflex"
          style="position: relative;border: 1px solid #e8e8e8;"
        >
          <div style="width: 980px;">
            <img
              style=" width: 980px;-webkit-user-drag: none;"
              :src="equipmentDrawing"
              alt=""
            />
          </div>
          <div class="drop-left flex1" :style="`height:100px; padding: 10px`">
            <!-- 相对定位 可移动的 -->
            <!-- :style="`left:${item.left + 100}px; top:${item.top}px`" -->
            <div class="drop-left-p">
              <img
                class="icon_cgq_right"
                style="position: absolute;width:40px;"
                v-for="(item, index) of dropDiaXYList"
                :key="index"
                :style="`left:${item.left - 7}px; top:${item.top - 5}px`"
                :data-index="index"
                name="sensor-p-item"
                :title="item.name"
                :src="`/static/image/${item.imgName || 'icon_sbxq'}.gif`"
                alt=""
              />
              <!-- <div
              class="icon_cgq_right success"
              v-for="(item,index) of dropDiaXYList"
              :key="index"
              :data-index="index"
              :style="`left:${item.left}px; top:${item.top}px`"
              name='sensor-p-item'
              :title="item.name"
              @mousedown="moveRightFunc($event, index)">
            </div> -->
            </div>
            <!-- 绝对定位 固定的 -->
            <div class="drop-left-a" style="display:none">
              <div
                v-for="(item, index) of dropDiaList"
                :key="index"
                :data-index="index"
                class="sensor-item sensor-a-item"
              >
                <div class="flex sensor-item-top">
                  <!-- << 图片 -->
                  <img
                    class="icon_cgq"
                    :src="`/static/image/${item.imgName || 'icon_cgq'}.png`"
                    alt=""
                  />
                  <!-- <div class="icon_cgq success"></div> -->
                  <!-- >> 图片 -->

                  <div
                    :class="
                      `flex1 not-select ${
                        item.isSelected ? 'fsuccess fbold' : ''
                      } `
                    "
                    style="line-height: 23px"
                  >
                    {{ item.name }}
                  </div>
                  <i
                    v-if="item.iconState"
                    class="el-icon-back fdanger fr"
                    @click="backFunc(index)"
                    style="font-size: 22px"
                    title="撤销"
                  ></i>
                  <!-- {{positionX}}
                {{positionY}} -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dropDiaState = false" icon="el-icon-back"
          >关闭</el-button
        >
        <!-- <el-button type="success" @click="subGiveAlarmDlg" icon="el-icon-check">
          <span>提交</span>
        </el-button> -->
      </div>
    </el-dialog>
    <Usertree />
  </div>
</template>

<script>
import { getAction, postAction } from "../../api";
import {
  arrId2Name, // 根据id 获取name
  isNull,
  getDataDictOther // 数据字典
} from "@/utils";
import Usertree from "@/components/Dialog/Usertree";
import { mapGetters } from "vuex";
import alarmDetailsDlg from "../../views/equipSafeMan/components/alarmDetailsDlg";
let dlgDataEmpty = {
  id: "",
  handlerId: "",
  handler: "",
  handlerRemark: "",
  confirmationTime: "",
  status: "",
  handlerHours: "",
  handlerResultStr: "",
  handlerResult: ""
};
export default {
  name: "AlarmNotification",
  components: {
    alarmDetailsDlg,
    Usertree
  },
  watch: {
    // 用户tree
    userTreeUserId(nVal) {
      if (this.dlgShow) {
        this.dlgData.handlerId = nVal;

        //console.log(this.dlgData.chargeLeaderId + "22222222222222");
        // this.dlgData = JSON.parse(JSON.stringify(this.dlgData));
      }
    },
    userTreeUserName(nVal) {
      if (this.dlgShow) {
        this.dlgData.handler = nVal;
        // this.dlgData = JSON.parse(JSON.stringify(this.dlgData));
      }
    }
  },
  computed: {
    ...mapGetters([
      // 部门
      "bmTreeBranchId",
      "bmTreeBranchName"
    ]),
    // 部门选人相关
    userTreeState: {
      get: function() {
        let userTreeState = this.$store.getters.userTreeState;
        return userTreeState;
      },
      set: function(newVal) {
        // this.$store.commit('SET_USERTREESTATE', newVal)
      }
    },
    userTreeUserId: {
      get: function() {
        let userTreeUserId = this.$store.getters.userTreeUserId;
        return userTreeUserId;
      },
      set: function(newVal) {
        // this.$store.commit('SET_USERTREEUSERID', newVal)
      }
    },
    userTreeUserName: {
      get: function() {
        let userTreeUserName = this.$store.getters.userTreeUserName;
        return userTreeUserName;
      },
      set: function(newVal) {
        // this.$store.commit('SET_USERTREEUSERNAME', newVal)
      }
    }
  },
  data() {
    return {
      dropDiaList: [
        { id: 1, name: "用电" },
        { id: 2, name: "环境参数" },
        { id: 23, name: "环境参数23" }
      ], // 传感器列表
      equipmentDrawing: "",
      equipmentDrawingList: [],
      dropDiaXYList: [], // 坐标
      isDis: false,
      dlgRules: {
        handlerRemark: [
          { required: true, message: "必填字段", trigger: "change" }
        ],
        handler: [{ required: true, message: "必填字段", trigger: "change" }],
        confirmationTime: [
          { required: true, message: "必填字段", trigger: "change" }
        ],
        handlerResultStr: [
          { required: true, message: "必填字段", trigger: "change" }
        ],
        status: [{ required: true, message: "必填字段", trigger: "change" }],
        handlerHours: [
          { required: true, message: "必填字段", trigger: "change" }
        ]
      },
      giveAlarmRow: {}, //报警详情/报警信息
      dlgType: "",
      dlgLoading: false,
      dlgShow: false,
      dlgData: JSON.parse(JSON.stringify(dlgDataEmpty)),
      dlgState: false,
      //查看大图dlg
      dropDiaState: false,
      gjSelect: [],
      dlgQuery: {},
      dlgType: "",
      srcList: [],
      alarmList: [],
      alarmDetailData:{},
      userInfo: {},
    };
  },
  methods: {
    //查看大图
    viewLargerImg() {
      this.dropDiaState = true;
    },
    // 选人弹窗
    showUserTree() {
      this.$store.commit("SET_USERTREESQTYPE", "");
      this.$store.commit("SET_USERTREESTATE", true);
    },
    // 添加报警通知
    addAlarm(alarmData) {
      console.log(alarmData,'alarmData');
      
      const alarm = {
        id: alarmData.id,
        name: alarmData.name || "未知设备",
        alertName: alarmData.alertName || "未知告警",
        area: alarmData.area || "-",
        content: alarmData.content || "暂无描述",
        createTime: alarmData.createTime || new Date().toLocaleString(),
        alarmSource: alarmData.alarmSource || "",
        duration: alarmData.duration || 0,
        nodeId: alarmData.nodeId,
        type: alarmData.type,
        equipName: alarmData.equipName,
        equipRoomId: alarmData.equipRoomId,
        alarmLevel: alarmData.alarmLevel,
        rawData: alarmData.rawData || {}
      };

      // 检查是否已存在相同的报警
      const existingAlarmIndex = this.alarmList.findIndex(
        a => a.id === alarm.id
      );
      if (existingAlarmIndex === -1) {
        this.alarmList.push(alarm);

        // 限制最多显示5个报警
        if (this.alarmList.length > 5) {
          this.alarmList.shift();
        }
      }
    },

    // 关闭报警通知
    closeAlarm(id) {
      const index = this.alarmList.findIndex(a => a.id === id);
      if (index > -1) {
        this.alarmList.splice(index, 1);
      }
    },

    // 处理报警
    handleAlarm(data) {
      // this.closeAlarm(data.id)
          this.userInfo = JSON.parse(window.localStorage.userInfo);
      getDataDictOther(this, "gaojingchulijieguo", "gjSelect"); // 报警处理结果
      console.log(data, "data");
      if (data.alarmSource == "LIFT_CAMERA") {
        this.dlgState = true;
        this.dlgQuery = data;
      } else {
        this.giveAlarmRow = data;
        this.srcList = [];
        if (data.status != 1 && data.status != 2) {
          this.dlgData = JSON.parse(JSON.stringify(dlgDataEmpty));
          this.isDis = false;
        } else if (data.status == 1) {
          this.dlgData.status = data.status;
          this.dlgData.handlerHours = data.handlerHours;
          this.isDis = true;
        } else {
          this.isDis = false;
          this.dlgData.status = data.status;
          this.dlgData.handlerHours = 0;
        }
        if (data.alarmPicture && data.alarmPicture != "") {
          this.srcList.push(data.alarmPicture);
        }
        console.log(this.srcList, "this.srcList");
        this.dlgData.id = data.id;
        if (data.type != 1) {
          this.getInfo1(data.nodeId);
        }
        this.dlgShow = true;
      }
    },
    getInfo1(id) {
      getAction(`/iot/findEquipNodeById/${id}`).then(res => {
        if (res.data.code == 200) {
          this.alarmDetailData = res.data.data;
          console.log(this.alarmDetailData, "this.alarmDetailData");
          this.getEquipmentDrawing(this.alarmDetailData.pojo.equipRoomId);
          this.dlgShow = true;
          this.$nextTick(() => {
            if (this.$refs["dlgForm"]) {
              this.$refs["dlgForm"].clearValidate();
            }
          });
        } else {
          this.$message({
            type: "warning",
            message: res.data.msg
          });
        }
      });
    },
    getEquipmentDrawing(id) {
      this.equipmentDrawing = "";
      this.equipmentDrawingList = [];
      getAction(`/iot/findListByEquipId/${id}`).then(res1 => {
        let res = res1.data;
        if (res.code == 200) {
          let dropDiaList = res.list;
          if (res.data.imgUrl != null && res.data.imgUrl != "") {
            this.equipmentDrawing = res.data.imgUrl;
            this.equipmentDrawingList = res.data.imgUrl.split(",");

            // 坐标 - 并将坐标渲染到画布上
            if (res.data.coordinate == null || res.data.coordinate == "") {
              this.dropDiaXYList = [];
            } else {
              let arr = [];
              let coordinate = JSON.parse(res.data.coordinate);
              let obj = coordinate.find(obj => {
                return obj.id == this.giveAlarmRow.nodeId;
              });
              if (obj != undefined) {
                arr.push(obj);
              } else {
                arr = [];
              }
              // console.log(obj,"obj");
              let dropDiaXYList = (this.dropDiaXYList = arr);
              // this.dropDiaXYList = JSON.parse(JSON.stringify(dropDiaXYList))
            }
            console.log(this.dropDiaXYList, "this.dropDiaXYList");
          } else {
            this.equipmentDrawing = "";
            this.equipmentDrawingList = [];
          }
          let img = new Image();
          img.src = this.equipmentDrawing;
          img.onload = async () => {
            this.imgWidth = 400 / img.width;
            this.imgHeight = 202 / img.height;
            if (img.width / img.height > 400 / 202) {
              this.imgWidth = 400;
              this.imgHeight = (img.height * 400) / img.width;
            } else {
              this.imgWidth = (img.width * 202) / img.height;
              this.imgHeight = 202;
            }
            this.iconScale1 = this.imgWidth / 980;
          };

          this.dropDiaList = JSON.parse(JSON.stringify(dropDiaList));
          // 图片高度
          setTimeout(() => {
            this.sbImgH = $(".drop-right-img").height() + 4;
          }, 500);
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
        console.log(res, "res");
      });
    },
    subGiveAlarmDlg() {
      this.$refs["dlgForm"].validate(valid => {
        if (valid) {
          if (this.giveAlarmRow.status == 1 && this.dlgData.status != 2) {
            this.$message.error("处理中报警不允许重复提交!");
            return false;
          }
          let sendObj = JSON.parse(JSON.stringify(this.dlgData));
          sendObj.id = this.giveAlarmRow.id;
          if (sendObj.status == "1") {
            sendObj.handlerId = 0;
          }
          if (this.giveAlarmRow.status == "1") {
            sendObj.handlerHours = this.giveAlarmRow.handlerHours;
          }
          // console.log(sendObj,"sendObj");
          // return
          postAction("/iot/aas/updateStatus/v2", sendObj).then(res => {
            console.log(res);
            if (res.data.code == 200) {
              if (this.dlgShow && !this.alarmRecordDlg) {
                this.dlgShow = false;
              }
              if (this.alarmRecordDlg) {
                this.dlgShow = false;
              }
              this.$message.success(res.data.msg);
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    radioChange() {
      this.dlgData.handlerId = "";
      this.dlgData.handler = "";
      this.dlgData.handlerRemark = "";
      this.dlgData.confirmationTime = "";
      this.dlgData.handlerHours = "";
      this.dlgData.handlerResultStr = "";
      this.dlgData.handlerResult = "";
      this.$nextTick(() => {
        this.$refs["dlgForm"].clearValidate();
      });
    },
    gjSelectProductType(data) {
      let { value, label } = data;
      this.dlgData.handlerResultStr = label;
      this.dlgData.handlerResult = value;
    },
    closeDlg(type) {
      this.dlgState = false;
    },
    // 清除所有通知
    clearAll() {
      this.alarmList = [];
    }
  }
};
</script>

<style scoped>
.message-notification-container {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 9999;
  display: flex;
  width: 330px;
  pointer-events: none;
  flex-direction: column;
  gap: 12px;
}

.notification-card {
  position: relative;
  display: flex;
  width: 330px;
  height: 219px;
  overflow: hidden;
  pointer-events: auto;
  background: url("/static/image/equip/ts-bj.png") no-repeat;
  background-position: center center;
  background-size: 100% 100%;
  border-radius: 10px;
  transition: all 0.3s ease;
  flex-direction: column;

  &:hover {
    transform: translateX(-4px);
  }
}

.notification-body {
  display: flex;
  height: 159px;
  padding: 12px 16px;
  overflow: hidden;
  flex: 1;
  flex-direction: column;
}

.notification-row {
  display: flex;
  height: 28px;
  margin-bottom: 10px;
  align-items: center;

  &:last-child {
    margin-bottom: 0;
  }

  .row-label {
    width: 50px;
    font-size: 14px;
    color: #fff;
    flex-shrink: 0;
  }

  &.device-name-row {
    height: 22px;
    margin-bottom: 5px;

    .device-name {
      font-size: 18px;
      font-weight: 500;
    }
  }

  .row-value {
    flex: 1;
    font-size: 14px;
    color: #fff;
    word-break: break-word;

    &.device-name {
      max-width: 290px;
      overflow: hidden;
      font-size: 16px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .type-value {
    font-weight: 500;
  }

  .content-ellipsis {
    display: inline-block;
    max-width: 230px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.notification-footer {
  display: flex;
  height: 60px;
  padding: 0 15px;
  margin-top: auto;
  align-items: center;
  gap: 10px;

  .btn-icon {
    width: 40px;
    height: 40px;
    margin-left: -15px;
    vertical-align: middle;
    flex-shrink: 0;
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    min-width: 90px;
    padding: 0 12px;
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
    cursor: pointer;
    border: none;
    border-radius: 6px;
    transition: all 0.2s;
    flex: 1;
  }

  .btn-handle {
    color: #fff;
    background: transparent;
    border: 1px solid #105891;

    &:hover {
      background: rgb(255 255 255 / 10%);
    }
  }

  .btn-close {
    color: rgb(255 255 255 / 80%);
    background: transparent;
    border: 1px solid #105891;

    &:hover {
      background: rgb(255 255 255 / 10%);
    }
  }
}

.notification-enter-active {
  animation: notificationIn 0.4s ease-out;
}

.notification-leave-active {
  animation: notificationOut 0.3s ease-in;
}

@keyframes notificationIn {
  0% {
    opacity: 0;
    transform: translateX(100%);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes notificationOut {
  0% {
    opacity: 1;
    transform: translateX(0);
  }

  100% {
    opacity: 0;
    transform: translateX(100%);
  }
}
</style>